var exports = {
  "r": "tooLargeWrapper__Ezm9Fn",
};

module.exports = exports;
